package org.chiangmeng.qfast.core.domain.models

// Data model representing queue history entry
data class QueueHistoryItem(
    val ticketNumber: Int,
    val servedAt: Long
)
